<div class="project-info">
  <div class="project-info-left">
    <div class="project-name">

      <mat-form-field appearance="outline">
        <mat-label>Workspace Name</mat-label>
        <input matInput [formControl]="filename" placeholder="Enter project name"
          (keyup.enter)="renameWorkspace(filename.value)">
        @if (filename.invalid && (filename.dirty || filename.touched)) {
        <mat-error>
          @if (filename.errors?.['required']) {
          Project name is required
          } @else if (filename.errors?.['minlength']) {
          Project name must be at least 1 character
          }
        </mat-error>
        }



      </mat-form-field>
      @if (filename.dirty) {
      <button mat-raised-button color="accent" (click)="renameWorkspace(filename.value)">
        Save
      </button>
      }

    </div>
    <div class="project-description">

      <mat-form-field appearance="outline">
        <mat-label>Project Description</mat-label>
        <textarea matInput (keyup.enter)="updateWorkspaceDescription(fileDescription.value)"
          [formControl]="fileDescription" placeholder="Enter project description" rows="4"></textarea>
      </mat-form-field>

      @if (fileDescription.dirty) {
      <button mat-raised-button color="accent" (click)="updateWorkspaceDescription(fileDescription.value)">
        Save
      </button>
      }

    </div>
  </div>




  <div class="project-info-right">

    @if(time) {
    <div class="project-created-at">
      <div class='project-info-field'>Last Saved:</div>
      <div class='project-info-value'>{{formatTime(time)}}</div>
    </div>
    }

    <div class="project-id">
      <div class='project-info-field'>AdaCAD Database ID</div>
      <div class='project-info-value'>{{ id }}</div>
    </div>

    @if(from_share) {
    <div class="project-owner">
      <div class='project-info-field'>Shared file credit line:</div>
      <div class='project-info-value'>{{projectOwner}}</div>
    </div>
    }



    <div class="project-info-actions">
      @if(!from_share){
      <button mat-raised-button matTooltip="share" color="primary" (click)="share()">
        <i class="fa-solid fa-share-nodes"></i> Share
      </button>
      }


    </div>


  </div>

</div>

<!-- Media Section -->
<section class="media-section" id="media">
  <h2>Media</h2>
  <div class="media-grid">
    @for (mediaItem of media; track mediaItem.media.id) {
    @if(mediaItem.media.img) {
    <div class="media-card">
      <div class="media-thumbnail">
        <img [src]="mediaItem.media.img.image.src" [alt]="mediaItem.media.img.name || 'Media item'"
          (error)="$event.target.style.display='none'">
      </div>



      <div class="media-info">
        <div class="media-name">{{ mediaItem.media.img.name || 'Unnamed Media' }}</div>
        <div class="media-type">
          <!-- <mat-chip [color]="mediaItem.media.type === 'indexed_color_image' ? 'primary' : 'accent'" selected>
            {{ mediaItem.media.type === 'indexed_color_image' ? 'Indexed Color' : 'Image' }}
          </mat-chip> -->

          @for (used_in of mediaItem.used_in; track used_in.id) {
          used in:
          <button mat-button (click)="openDraftInMixer(used_in.id)" [style.background-color]="used_in.color">
            <i class="fas fa-eye"></i>
            {{ used_in.name }}
          </button>
          }
        </div>
        <div class="media-dimensions">
          {{ mediaItem.media.img.width }} × {{ mediaItem.media.img.height }}px
        </div>

        <div class="media-actions">
          <button mat-icon-button matTooltip="Download media item" (click)="downloadMediaItem(mediaItem.media)"
            color="primary">
            <i class="fas fa-download"></i>
          </button>
          @if(mediaItem.used_in.length === 0) { <button mat-icon-button matTooltip="delete media item"
            (click)="deleteMediaItem(mediaItem.media)" color="primary">
            <i class="fas fa-trash"></i>
          </button>
          }

        </div>
      </div>

    </div>
    }
    }
  </div>
  @if (media.length === 0) {
  <p class="empty-message">No media uploaded to this workspace.</p>
  }
</section>

<!-- Drafts Section -->
<section class="drafts-section">
  <h2>Drafts</h2>
  <div class="draft-actions">
    @if (draftsData.length > 0) {




    <button mat-raised-button color="primary" (click)="downloadAllDraftsAsBitmaps()">
      <i class="fas fa-download"></i>
      @if (getSelectedDraftsCount() > 0) {
      Download Selected Drafts as Bitmaps
      } @else {
      Download All Drafts as Bitmaps
      }
    </button>

    @if (getSelectedDraftsCount() > 0) {
    <button mat-raised-button color="primary" (click)="hideSelectedDrafts()">
      <i class="fas fa-eye-slash"></i>
      Hide Selected Drafts
    </button>
    }
    }

    @if (hiddenDrafts.length > 0) {
    <button mat-raised-button color="none" (click)="showHiddenDrafts()">
      <i class="fas fa-eye"></i>
      Show {{hiddenDrafts.length}} Hidden Drafts
    </button>
    }

    <div class="draft_import">

      <button [disabled]="!connection_state" [matMenuTriggerFor]="importFile" mat-raised-button>
        <i class="fas fa-upload"></i>
        Import Drafts
      </button>


      <mat-menu #importFile="matMenu">
        <button mat-menu-item (click)="importFrom('bitmap')">...from Bitmap(s)</button>
        <button mat-menu-item (click)="importFrom('wif')">...from .WIF File(s)</button>
      </mat-menu>

    </div>
  </div>


  <div>
    <div class="drafts-grid">
      @for(draft of draftsData; track draft.uid) {
      <app-draftinfocard [id]="draft.id" (onDraftSelectionChange)="toggleDraftSelection($event)"
        (onDraftRename)="onDraftRename($event)" (onOpenInEditor)="openDraftInEditor($event)"
        (onOpenInMixer)="openDraftInMixer($event)"></app-draftinfocard>
      <!-- <div class="draft-card" [formGroupName]="$index">
       
 
    
    

       


 

        <div class="draft-actions">
          <button matIconButton matTooltip="download draft" (click)="downloadDraft(draft.get('id')?.value)">
            <i class="fas fa-download"></i>
          </button>
          <button matIconButton matTooltip="open in mixer" (click)="downloadDraft(draft.get('id')?.value)">
            <i class="fa-code-branch fa-solid"></i>
          </button>
          <button matIconButton matTooltip="open in editor" (click)="downloadDraft(draft.get('id')?.value)">
            <i class="fa-pen-to-square fa-solid"></i>
          </button>
        </div>
      </div> -->
      }
    </div>
  </div>

  @if (draftsData.length === 0) {
  <p class="empty-message">No drafts in this workspace.</p>
  }
</section>

<!-- Materials Section -->
<section class="materials-section" id="materials">
  <h2>Materials</h2>

  <div class="materials-actions">
    <button mat-raised-button color="primary" (click)="exportMaterialsAsCSV()">
      <i class="fas fa-download"></i>
      Export Materials as CSV
    </button>
    <button mat-raised-button (click)="triggerCSVImport()">
      <i class="fas fa-upload"></i>
      Import Materials from CSV
    </button>
  </div>

  <app-material #materials></app-material>

</section>


<!-- Hidden canvas for downloading drafts -->
<canvas #hiddenCanvas style="display: none;"></canvas>

<!-- Hidden file input for CSV import -->
<input #csvFileInput type="file" accept=".csv" style="display: none;" (change)="onCSVFileSelected($event)">